import { useEffect, useState } from "react";
import { api } from "../api";
import { Notice } from "../components";

const CODE: Record<string, string> = { appointment_confirmation: "Booking confirmation", appointment_reminder: "Reminder", appointment_cancelled: "Cancellation" };
const STATUS: Record<string, string> = { queued: "Scheduled", sent: "Sent", failed: "Not sent", skipped: "Skipped", cancelled: "Cancelled" };
const WHY: Record<string, string> = { no_consent: "patient declined messages", no_mobile: "no mobile number", appointment_changed: "appointment changed",
  appointment_cancelled: "appointment cancelled", appointment_rescheduled: "appointment moved", appointment_no_show: "patient did not come", no_template: "no template" };

export function Messages() {
  const [data, setData] = useState<{ items: any[]; providers: { channel: string; name: string; configured: boolean }[] } | null>(null);
  useEffect(() => { api.authed("/api/v1/messages").then(setData).catch(() => {}); }, []);
  if (!data) return <p className="muted">Loading…</p>;
  return (
    <>
      <h1>Messages</h1>
      <ul className="provider-list">{data.providers.map((p) => (
        <li key={p.channel}><strong>{p.channel === "sms" ? "SMS" : p.channel === "whatsapp" ? "WhatsApp" : p.channel}</strong>: {p.configured ? p.name : "Not connected. Messages are not delivered until a provider is set up (Integration Ready)."}</li>))}
      </ul>
      {data.providers.some((p) => p.name.startsWith("Development")) && <Notice tone="info">Development mode: "sent" means recorded in a test outbox. No message reaches a phone.</Notice>}
      {!data.items.length ? <p className="empty">No messages yet. Booking an appointment queues a confirmation and a reminder.</p> : (
        <table className="data">
          <thead><tr><th scope="col">When</th><th scope="col">Type</th><th scope="col">Channel</th><th scope="col">Status</th><th scope="col">Text</th></tr></thead>
          <tbody>{data.items.map((m) => (
            <tr key={m.id}>
              <td className="small">{new Date(m.sentAt ?? m.scheduledFor).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" })}</td>
              <td>{CODE[m.code] ?? m.code}</td><td>{m.channel.toUpperCase()}</td>
              <td><span className={`msg-status ms-${m.status}`}>{STATUS[m.status]}</span>{m.lastError && m.status !== "sent" && <><br /><span className="muted small">{WHY[m.lastError] ?? m.lastError.split(":")[0]}</span></>}</td>
              <td className="small">{m.body ?? <span className="muted">Written when sent</span>}</td>
            </tr>))}
          </tbody>
        </table>)}
    </>
  );
}
